import axios from "axios";
import { getSupabaseRefreshToken } from "./supabaseStorage";
import { supabase } from "./supabaseClient";
import { BASE_API_URL } from "../config/api";

// Single owner of refresh logic for the CRA app.
// Supports both Supabase Auth session refresh and Spring Boot legacy fallback.
export async function refreshAuthToken(tokenDetails) {
  const supabaseRT = getSupabaseRefreshToken();
  if (supabaseRT) {
    try {
      const { data, error } = await supabase.auth.refreshSession();
      if (!error && data?.session) {
        return {
          id_token: data.session.access_token,
          refresh_token: data.session.refresh_token,
          expiresIn: data.session.expires_in,
          __fromSupabaseSdk: true,
        };
      }
    } catch (e) {
      console.warn("[AUTH] supabase refreshSession failed, checking fallback:", e);
    }
  }

  // Fallback to legacy backend /token/refresh for Spring Boot compatibility (PR #230)
  const tokenRefresh = tokenDetails?.refresh_token;
  if (tokenRefresh && BASE_API_URL) {
    const { data } = await axios.get(`${BASE_API_URL}/token/refresh`, {
      headers: {
        Authorization: `Bearer ${tokenRefresh}`,
        refreshToken: tokenRefresh,
      },
    });
    return {
      id_token: data.id_token,
      refresh_token: data.refresh_token,
      expiresIn: data.expiresIn || 3600,
      __fromSupabaseSdk: false,
    };
  }

  throw new Error("No refresh token available — user must re-login");
}
